import React from 'react'
import { graphql } from 'gatsby'
import { Section, SEO, PageContent, Gap, Title } from '../components'
import { extractNodesFromData } from '../lib/helpers'

class PageTemplate extends React.Component {
  render() {
    const {
      location: { pathname },
      data,
      pageContext,
    } = this.props
    const { page, contentImages } = data

    if (!page) return null
    return (
      <>
        <SEO
          title={`${page.metaTitle || page.header}`}
          description={
            page.metaDescription ||
            'We are developing a modern private aircraft with vertical takeoff and landing. This will allow you to affordably travel from city to city at distances of up to 700 km apart.'
          }
          pathname={pathname}
        />
        <Gap.Top />
        <Gap gap="140px" mobileGap="40px" />
        <Section background="black">
          <Title.Big
            innerAs="h1"
            fontWeight="400"
            white
            black={false}
            uppercase
            textAlign="center"
          >
            {page.header}
          </Title.Big>
        </Section>
        <Gap gap="80px" mobileGap="40px" />

        <PageContent
          page={page}
          contentImages={contentImages.edges.map((edge) => edge.node)}
        />
      </>
    )
  }
}

export default PageTemplate

export const pageQuery = graphql`
  query ($slug: String!) {
    contentImages: allFile(
      filter: { relativePath: { regex: "/^uploaded-image-/" } }
    ) {
      edges {
        node {
          ...PostContentImage
          relativePath
        }
      }
    }

    page: pages(slug: { eq: $slug }, state: { eq: "published" }) {
      id
      content
      header
      slug
      metaTitle
      metaDescription
      state
      createdAt
    }
  }
`
